import React, {Fragment} from "react";
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import Footer from "../footer";
import Header from "../header";
import Hero from "../hero";
import Page from "../page";
import {configSelector} from "../../state/config/configSelectors";
import {hubSelector} from "../../state/hub/hubSelectors";
import {getPageTitle} from "../../utils/other";

const ServiceUnavailable = ({defaultNode}) => {
  const {t} = useTranslation();
  const location = useLocation();

  const hub = useSelector(hubSelector);
  const config = useSelector(configSelector);

  return (
    <Fragment>
      <HashLink to={{hash: "#main", search: location.search}} className="skip-link sr-only">
        {t("commons.hashLinks.main")}
      </HashLink>
      <HashLink to={{hash: "#footer", search: location.search}} className="skip-link sr-only">
        {t("commons.hashLinks.footer")}
      </HashLink>
      <Page title={getPageTitle([t("scenes.serviceUnavailable.title"), hub?.hub?.name], t)}>
        <Header />
        <Box
          component="main"
          id="main"
          sx={{
            width: "100%",
            height: "100%",
            position: "fixed",
            display: "flex",
            flexDirection: "column",
            "& #footer": {
              paddingTop: "0px"
            }
          }}
        >
          <Hero
            title={t("scenes.serviceUnavailable.text.main")}
            slogan={t("scenes.serviceUnavailable.text.secondary")}
            background={defaultNode ? defaultNode?.backgroundMediaURL : hub?.backgroundMediaURL}
            backgroundFallback={
              defaultNode ? (
                <div
                  style={{
                    background: `url("${config.clientBasePath}/config/images/default-node-background.jpg") center center / cover no-repeat`
                  }}
                />
              ) : null
            }
          />
          <Footer />
        </Box>
      </Page>
    </Fragment>
  );
};

export default ServiceUnavailable;
